let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lqXcv")).then(() => parcelRequire('rN6yJ'));